import { render } from "./PlansThankyou.vue?vue&type=template&id=282f5fd1"
import script from "./PlansThankyou.vue?vue&type=script&lang=js"
export * from "./PlansThankyou.vue?vue&type=script&lang=js"

import exportComponent from "/home/crm/ganarcrm_vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__